import React from 'react';
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';

export default function OtpVerifyPage({ closeOtpAction }) {
  return (
    <div
      style={{
        display: 'flex',
        // padding: 16,
        borderRadius: 12,
        backgroundColor: colors.white,
        height: '80vh',
        width: 400,
        flexDirection: 'column',
      }}
    >
      <div
        role="button"
        onClick={closeOtpAction}
        style={{ marginLeft: 'auto', marginTop: -10, marginRight: -10 }}
      >
        <img src={images.CMClose} style={{ height: 30, width: 30 }} />
      </div>
      <div style={{ width: 400, marginTop: 20 }}>
        <div className="mb-3 mt-1" style={{ width: '100%' }}>
          <h6
            style={{ fontSize: 12, color: colors.black, fontWeight: 'bold' }}
            className="form-label"
          >
            Enter OTP to verify
          </h6>
          <input
            type="text"
            className="form-control"
            id="exampleFormControlInput1"
            placeholder="x-x-x-x-x-x"
          />
        </div>
        <h6 style={{ fontSize: 12, color: colors.greys04 }} className="form-label">
          OTP sent to “9876543210”
        </h6>

        <button type="button" className="btn btn-outline-dark mt-3">
          Resend OTP
        </button>
      </div>
      <div style={{ width: '100%', marginTop: 'auto', marginBottom: '5%' }}>
        <button style={{ width: '100%' }} type="button" className="btn btn-dark">
          Verify OTP
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {},
};
